export class InviteUserModel {
    first_name: string = '';
    last_name: string = '';
    email: string = '';
    referred_by: string = '';
    api_plan_id: string = '';
    account_id: number = 0;
    is_admin: boolean = false;
}
